import { initializeApp } from "firebase/app"
import { getAnalytics, isSupported } from "firebase/analytics"
import { getAuth, GoogleAuthProvider } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

// Firebase configuration provided for the Neo app
const firebaseConfig = {
  apiKey: "AIzaSyB4JpIUIKfdz8y_IBGtICTKpKwfXcrHVMo",
  authDomain: "neo-v0.firebaseapp.com",
  projectId: "neo-v0",
  storageBucket: "neo-v0.firebasestorage.app",
  messagingSenderId: "352932199026",
  appId: "1:352932199026:web:9df6589a6d126cf9bd20eb",
  measurementId: "G-SE9477ZHYS",
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()
const db = getFirestore(app)

// Analytics only runs in supported browser environments
let analytics
if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app)
      }
    })
    .catch(() => {
      // Analytics support isn't critical for auth, so ignore failures
    })
}

export { app, auth, googleProvider, analytics, db }
